export const common = {
  nav: {
    home: 'Home',
    about: 'About',
    products: 'Products',
    affiliate: 'Become an Affiliate',
    contact: 'Contact',
    cart: 'Cart',
  },
  hero: {
    title1: 'Discover the Premium Selection',
    title2: 'of NOZA Nuts',
    tagline: 'Pure Selected',
    cta: 'Explore Our Products',
  },
  about: {
    label: 'Our Story',
    title1: 'Algerian',
    title2: 'Excellence',
    description: "NOZA was born from a passion for exceptional nuts and a commitment to quality. Based in Algeria, our brand meticulously selects each pistachio, cashew, and almond to offer you an incomparable taste experience. Our artisanal roasting methods preserve natural flavors and nutritional benefits. Each nut is hand-selected by our experts, ensuring consistent quality and optimal freshness. Our commitment to excellence is reflected in every NOZA package.",
    card1Title: '100%',
    card1Subtitle: 'Natural',
    card1Text: 'No artificial additives',
    card1Tagline: 'Purity in every bite',
    card2Title: '15+',
    card2Subtitle: 'Years of experience',
    card2Text: 'In premium selection',
    cta: 'Discover Our Process',
  },
  products: {
    title: 'Our Signature Products',
    subtitle: 'Artisanal selection of premium nuts',
    viewDetails: 'View Details',
    delivery: 'Delivery available in Algeria',
  },
  cart: {
    title: 'My Cart',
    empty: 'Your cart is empty',
    goShopping: 'Continue shopping',
    orderSummary: 'Order Summary',
    total: 'Total',
    confirm: 'Confirm Order',
    remove: 'Remove',
    subtotal: 'Subtotal',
    item: 'Item',
    items: 'Items',
    shippingInfo: 'Shipping Information',
    paymentMethod: 'Payment Method',
    cod: 'Cash on Delivery (COD)',
  },
  orderType: {
    label: 'Order Type',
    particulier: 'Individual',
    magasin: 'Store',
    particulierDesc: 'For individuals: order your packs in small quantities.',
    magasinDesc: 'For stores: order a box containing 10 NOZA products. Select the number of boxes you want.',
    required: 'Please choose an order type',
    boxInfo: '1 box = 10 products',
    boxCount: 'Number of boxes',
    totalProducts: 'You will receive {boxes} boxes × 10 products = {total} products in total',
    box: 'box',
    boxes: 'boxes',
    pack: 'pack',
    packs: 'packs',
  },
  toast: {
    addedToCart: '{product} added to cart!',
    orderConfirmed: 'Order confirmed! You will receive a confirmation call or email soon.',
    success: 'Success',
    error: 'Error',
  },
  footer: {
    newsletter: 'Stay Informed',
    newsletterDesc: 'Receive our exclusive offers and news',
    emailPlaceholder: 'Your email address',
    subscribe: 'Subscribe',
    navigation: 'Navigation',
    contact: 'Contact',
    address: 'Address',
    addressLine1: 'Algiers, Algeria',
    addressLine2: 'Industrial zone',
    copyright: '© 2025 NOZA Nuts. All rights reserved.',
    privacy: 'Privacy Policy',
    terms: 'Terms of Use',
  },
  common: {
    learnMore: 'Learn More',
    orderNow: 'Order Now',
    addToCart: 'Add to Cart',
    submit: 'Submit',
    close: 'Close',
  },
};